export const SET_PRODUCT_SERVICE = (state, productService) => {
  state.productService = productService;
};

export const SET_ORDER = (state, order) => {
  state.order = order;
};

export const SET_WH_ORDER_EXPIRATION = (state, whOrderExpiration) => {
  state.whOrderExpiration = whOrderExpiration;
};

export const RESET_CHECKOUT = (state) => {
  state.productService = null;
  state.order = null;
  state.whOrderExpiration = null;
};
